/*  ========================================================================
    # Scripts - Share Bar
    ========================================================================  */

/**
 * Share bar functionality.
 */
const ShareBar = {
    cfg: {
        shareBar: document.querySelector('.c-share-bar'),
        trigger: document.querySelector('.c-share-bar__trigger'),
        buttons: document.querySelector('.c-share-bar__buttons'),
        classes: {
            active: 'c-share-bar--active'
        }
    },

    /**
     * Toggle share buttons visibility.
     */
    toggleButtons() {
        if (!this.cfg.shareBar) return;

        this.cfg.shareBar.classList.toggle(this.cfg.classes.active);
        const isExpanded = this.cfg.trigger.getAttribute('aria-expanded') === 'true';
        this.cfg.trigger.setAttribute('aria-expanded', !isExpanded);
    },

    /**
     * Initialize.
     */
    init() {
        if (!this.cfg.shareBar || !this.cfg.trigger) return;

        this.cfg.trigger.setAttribute('aria-expanded', 'false');
        this.cfg.trigger.addEventListener('click', () => this.toggleButtons());
    }
};

export default ShareBar;
